(function (root) {
  'use strict';
  var units = { inch: 25.4, inches: 25.4, in: 25.4, cm: 10, cms: 10, mm: 1 };
  var names = { length: 'Length', width: 'Width', diameter: 'Diameter', circumference: 'Circumference', idol: 'Idol height', size: 'Size' };
  function rounded(value) { return Math.round(value * 10000) / 10000; }
  function parse(text, sizeValues) {
    var result = { dimensions: {}, universal: /all sizes of fiber idols/i.test(text) };
    var pattern = /(\d+(?:\.\d+)?)\s*(?:(?:to|[-\u2013\u2014])\s*(\d+(?:\.\d+)?)\s*)?(inches|inch|cms|cm|mm|in)\b/gi;
    String(text).split(/\n|<br\s*\/?\s*>|\s*\/\s*/i).forEach(function (line) {
      var axis = /suitable.*idol/i.test(line) ? 'idol' : /circumference/i.test(line) ? 'circumference' : /diameter/i.test(line) ? 'diameter' : /width/i.test(line) ? 'width' : /length|height/i.test(line) ? 'length' : 'size';
      var match;
      pattern.lastIndex = 0;
      while ((match = pattern.exec(line))) {
        var factor = units[match[3].toLowerCase()];
        var min = Number(match[1]), max = Number(match[2] || match[1]);
        if (max < min) continue;
        var values = result.dimensions[axis] || (result.dimensions[axis] = []);
        values.push({ min: rounded(min * factor), max: rounded(max * factor), value: min, end: max, unit: match[3].toLowerCase(), text: line.trim() });
      }
    });
    // A selectable variant is more precise than the sheet's compatible-idol range.
    if (result.dimensions.idol && sizeValues) {
      var variants = parse(sizeValues.replace(/\|/g, '\n'), '').dimensions.size;
      if (variants && variants.length) result.dimensions.idol = variants;
    }
    return result;
  }
  function selectedEntries(selection) {
    return Object.keys(names).filter(function (key) { return selection[key] !== undefined && selection[key] !== ''; });
  }
  function matches(record, selection) {
    var keys = selectedEntries(selection);
    if (!keys.length) return true;
    var checks = keys.map(function (key) {
      if (key === 'idol' && record.universal) return true;
      var target = Number(selection[key]);
      return (record.dimensions[key] || []).some(function (range) { return target >= range.min - 0.0001 && target <= range.max + 0.0001; });
    });
    return checks.some(Boolean);
  }
  function choices(records, axis) {
    var values = new Map();
    records.forEach(function (record) {
      (record.dimensions[axis] || []).forEach(function (range) {
        var points = [range.value];
        if (range.end > range.value) {
          for (var i = Math.ceil(range.value); i <= range.end; i++) points.push(i);
          points.push(range.end);
        }
        points.forEach(function (value) {
          var key = rounded(value * units[range.unit]);
          if (!values.has(key)) values.set(key, { value: key, label: value + ' ' + (/^in/.test(range.unit) ? (value === 1 ? 'inch' : 'inches') : /^cm/.test(range.unit) ? 'cm' : 'mm') });
        });
      });
    });
    return Array.from(values.values()).sort(function (a, b) { return a.value - b.value; });
  }
  function matchedLabels(record, selection) {
    var labels = [];
    selectedEntries(selection).forEach(function (key) {
      if (key === 'idol' && record.universal) labels.push('Suitable for all sizes of Fiber Idols');
      (record.dimensions[key] || []).forEach(function (range) {
        var value = Number(selection[key]);
        if (value >= range.min - 0.0001 && value <= range.max + 0.0001 && !labels.includes(range.text)) labels.push(range.text);
      });
    });
    return labels;
  }
  var api = { parse: parse, matches: matches, choices: choices, matchedLabels: matchedLabels, names: names, selectedEntries: selectedEntries };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.HonnarasMeasurements = api;
})(typeof window !== 'undefined' ? window : globalThis);
